import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ExplorePages from "@/components/ExplorePages";
import TestimonialsSection from "@/components/TestimonialsSection";
import WhyChooseUsSection from "@/components/WhyChooseUsSection";
import ProcessSection from "@/components/ProcessSection";
import BookingSection from "@/components/BookingSection";
import ContactSection from "@/components/ContactSection";
import AboutSection from "@/components/AboutSection";
import Footer from "@/components/Footer";
import { MorphPanel } from "@/components/ui/ai-input";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-void">
      <Navbar />
      <main>
        <HeroSection />
        <TestimonialsSection />
        <ExplorePages />
        <WhyChooseUsSection />
        <ProcessSection />
        <BookingSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
      <MorphPanel />
    </div>
  );
};

export default LandingPage;
